<template>
  <div class="room-info-content">
    <div class="room-type-btns">
      <div class="btn-item" :class="{
        'btn-active': activeIndex === index,
        'btn-ready': activeIndex + 1 === index || index === 0 && activeIndex === roomInfo.length - 1,
        'btn-animate': isAnimate && !isMobile
      }" v-for="(item, index) in roomInfo" :key="item.orderItemCode" :style="{
        top: isMobile ? '0' : `${getBtnTop(index)}px`,
        left: isMobile ? `${getBtnLeft(index)}%` : '0',
        transition: (isAnimate && !isMobile) ? '.5s ease' : 'none'
      }" @click="roomTypeClick(index, item)">
        <div class="room-type">{{ item.itemCname }}</div>
        <div class="img">
          <img :src="item.upImgUrl" alt="" lazy>
        </div>
      </div>
    </div>

    <div class="info-container">
      <div class="info-item info-left">
        <p class="info-text">{{ roomInfo[activeIndex]?.infoMessage }}</p>
        <a href="/room" class="btn btn-primary" >了解更多</a>
      </div>
      <div class="info-item info-right">
        <div class="img-item up-img" :class="{ 'img-active-right': showImg && !isMobile }">
          <img :src="upImgUrl" alt="" lazy>
        </div>
        <div class="img-item down-img" :class="{ 'img-active-left': showImg && !isMobile }">
          <img :src="downImgUrl" alt="" lazy>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetRoomPriceList } from "@/utils/roomRequest";
import roomImgs from "@/assets/json/roomImgs.json";


// 节流函数-解决scroll卡顿 最小改动
const throttle = (fn, delay = 200) => {
  let timer = null;
  return function (...args) {
    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(this, args);
        timer = null;
      }, delay);
    }
  };
};

export default {
  data() {
    return {
      isScrolled: false,
      scrollThreshold: 420,
      activeIndex: 0,
      roomInfo: [],
      isAnimate: false,
      btnHeight: 100,
      btnWidth: 120,
      downImgUrl: '',
      upImgUrl: '',
      timer: '',
      showImg: true,
      showItem: false,
      isMobile: false,
      autoTimer: '',
      startAutoPlayer: '',
      roomImageSData: roomImgs.roomImageSData,
    };
  },
  mounted() {
    // 节流处理scroll-解决高频触发卡顿
    window.addEventListener("scroll", throttle(this.handleScroll.bind(this)));
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getRoomPriceList();
    
  },
  beforeUnmount() {
    window.removeEventListener("scroll", throttle(this.handleScroll.bind(this)));
    window.removeEventListener("resize", this.handleResize);
    // 统一清除定时器-解决内存泄漏
    this.clearAllTimers();
  },
  methods: {
    // 统一清除定时器-最小改动
    clearAllTimers() {
      this.autoTimer && clearInterval(this.autoTimer);
      this.timer && clearTimeout(this.timer);
      this.startAutoPlayer && clearTimeout(this.startAutoPlayer);
      this.autoTimer = this.timer = this.startAutoPlayer = '';
    },
    handleResize() {
      const isMobileNow = window.innerWidth <= 768;
      this.isMobile = isMobileNow;
      if (isMobileNow) {
        this.clearAllTimers();
        this.isAnimate = false;
      } else {
        this.$nextTick(() => {
          this.isAnimate = true;
          if (!this.autoTimer && this.roomInfo.length > 0) {
            this.autoPlay();
          }
        });
      }
    },
    // 优化图片查找-用find替代forEach 减少计算
    imgUrl(roomType, idx) {
      const base = 'https://www.hqhotel5.com/img/hotelImgs/';
      const item = this.roomImageSData.find(i => i.name === roomType);
      return item ? `${base}${item.imgs[idx] || item.imgs[0]}` : base;
    },
    async getRoomPriceList() {
      try {
        const res = await GetRoomPriceList({
          BeginDate: "2025-12-17",
          EndDate: "2025-12-18",
          ProfileId: "",
          RoomQty: "1",
          OrderItemCode: "",
        });
        const data = res.data.roomTypePricesList?.rows?.row || [];
        this.roomInfo = data.map((item) => ({
          ...item,
          infoMessage: `伍号酒店${item.itemCname}给你带来极致享受`,
          upImgUrl: this.imgUrl(item.itemCname, 0),
          downImgUrl: this.imgUrl(item.itemCname, 1),
        }));
        if (this.roomInfo.length > 0) {
          this.upImgUrl = this.roomInfo[0].upImgUrl;
          this.downImgUrl = this.roomInfo[0].downImgUrl;
          this.$nextTick(() => {
            this.isAnimate = !this.isMobile;
            !this.isMobile && this.autoPlay();
          });
        }
      } catch (error) {
        console.error("获取房型列表失败：", error);
      }
    },
    // 简化滚动逻辑-减少冗余判断
    handleScroll() {
      if (this.isMobile || this.isScrolled) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop >= this.scrollThreshold) {
        this.isScrolled = true;
        setTimeout(() => {
          this.showItem = true;
        }, 400);
      }
    },
    // 简化切换逻辑-减少DOM更新卡顿
    handleBtnClick(targetIndex, item) {
      if (targetIndex === this.activeIndex) return;
      this.clearAllTimers();
      this.showImg = false;
      this.activeIndex = targetIndex;
      this.timer = setTimeout(() => {
        this.upImgUrl = item.upImgUrl;
        this.downImgUrl = item.downImgUrl;
        this.showImg = true;
        !this.isMobile && (this.startAutoPlayer = setTimeout(() => this.autoPlay(), 8000));
      }, 300); // 缩短过渡-提升流畅
    },
    roomTypeClick(idx, item) {
      this.handleBtnClick(idx, item);
    },
    autoPlay() {
      if (this.isMobile || this.roomInfo.length === 0) return;
      this.autoTimer = setInterval(() => {
        const idx = this.activeIndex + 1 >= this.roomInfo.length ? 0 : this.activeIndex + 1;
        this.handleBtnClick(idx, this.roomInfo[idx]);
      }, 6000);
    },
    getBtnTop(index) {
      const { activeIndex, btnHeight, roomInfo } = this;
      if (index === activeIndex) return 0;
      return index > activeIndex ? (index - activeIndex) * btnHeight : (roomInfo.length - activeIndex + index) * btnHeight;
    },
    getBtnLeft(index) {
      const { activeIndex, btnWidth } = this;
      const centerPercent = 50;
      const percentPerBtn = (btnWidth + 10) / window.innerWidth * 100;
      const baseLeft = centerPercent - (btnWidth / 2);
      if (index === activeIndex) return baseLeft;
      return index > activeIndex ? baseLeft + (index - activeIndex) * percentPerBtn : baseLeft - (activeIndex - index) * percentPerBtn;
    }
  },
};
</script>

<style scoped lang="scss">
// 全局变量-统一酒店轻奢风配色
$primary: #012059;
$primary-light: rgba(1, 32, 89, 0.85);
$primary-hover: #02307a;
$white: #ffffff;
$gray-light: rgba(255, 255, 255, 0.95);
$shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
$shadow-hover: 0 6px 20px rgba(0, 0, 0, 0.12);
$radius-sm: 8px;
$radius-md: 16px;
$radius-lg: 50px;

.room-info-content {
  height: 80vh;
  width: 90vw;
  position: relative;
  margin: 0 auto;
  padding-top: 30px;
  overflow: hidden;
  transition: all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);

  // 优化显隐动画-用3d变换开启GPU加速 解决卡顿  
  .room-type-btns,  
  .info-container { 
    position: relative;
    width: 100%;
    height: 100%;
    transition: all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
    will-change: opacity, transform;
    transform: translate3d(0, 20px, 0);
    z-index: 199;
    }

  .room-type-btns {
    position: absolute;
    top: 30px;
    left: 0;
    z-index: 100;

    .btn-item {
      position: absolute;
      left: 0;
      width: 10%;
      padding: 10px;
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      border-radius: $radius-lg;
      will-change: top, left, width;
      text-align: center;
      background: linear-gradient(to right, $primary-light, $primary-light);
      color: $white;
      box-sizing: border-box;
      // GPU加速-解决top/left动画卡顿
      transform: translate3d(0, 0, 0);
      border: 2px solid transparent;

      .room-type {
        width: 0;
        overflow: hidden;
        transition: .5s ease;
        word-break: keep-all;
        font-weight: 600;
        font-size: 16px;
      }

      .img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        overflow: hidden;
        transition: .5s ease;
        border: 2px solid $white;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &:hover {
        width: 15%;
        background: linear-gradient(to right, $primary-hover, $primary-hover);

        .img {
          transform: rotate(360deg);
        }

        .room-type {
          width: 50%;
          font-size: 18px;
        }
      }
    }

    .btn-ready {
      width: 15%;

      .img {
        transform: rotate(360deg);
      }

      .room-type {
        width: 50%;
        font-size: 18px;
      }
    }

    .btn-active {
      border-radius: $radius-lg 0 0 $radius-lg;
      pointer-events: none;
      background: linear-gradient(to right, $primary-light, transparent);
      width: 70%;
      border-color: rgba($white, 0.3);

      .img {
        transform: rotate(720deg);
        opacity: 0;
      }

      .room-type {
        width: 85%;
        font-size: 30px;
        text-align: center;
      }
    }
  }

  .info-container {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 10px;

    .info-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 20px;
    }

    .info-left {
      .info-text {
        font-size: 18px;
        line-height: 1.8;
        margin-bottom: 30px;
        color: #333;
        max-width: 80%;
        text-align: center;
        font-weight: 400;
      }

      .btn-primary {
        padding: 12px 36px;
        background: linear-gradient(135deg, $primary, $primary-hover);
        color: $white;
        border-radius: $radius-lg;
        text-decoration: none;
        border: none;
        transition: all 0.3s ease;
        font-size: 16px;
        font-weight: 500;
        box-shadow: $shadow;

        &:hover {
          background: linear-gradient(135deg, $primary-hover, $primary);
          transform: translateY(-2px);
          box-shadow: $shadow-hover;
        }
      }
    }

    .info-right {
      position: relative;
      padding: 0;

      .img-item {
        position: absolute;
        max-width: 400px;
        height: 70%;
        border-radius: $radius-md;
        overflow: hidden;
        transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        border: 3px solid $white;
        box-shadow: $shadow;
        // GPU加速-解决图片动画卡顿
        transform: translate3d(0, 0, 0);
        will-change: left, right, opacity;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .up-img {
        top: 0;
        opacity: 0;
        right: -100%;
      }

      .down-img {
        bottom: 50px;
        opacity: 0;
        left: -100%;
      }

      .img-active-right {
        right: 0;
        opacity: 1;
        box-shadow: $shadow-hover;
      }

      .img-active-left {
        left: -35%;
        opacity: 1;
        box-shadow: $shadow-hover;
      }
    }
  }
}

// 移动端高级UI重构-768px以下 酒店轻奢风
@media (max-width: 768px) {
  $m-radius: 16px;
  $m-shadow: 0 3px 12px rgba(1, 32, 89, 0.1);
  $m-shadow-active: 0 5px 18px rgba(1, 32, 89, 0.15);

  .room-info-content {
    height: auto;
    min-height: 100vh;
    width: 95vw;
    padding: 20px 0 40px;
    overflow: visible !important;

    .room-type-btns {
      position: relative !important;
      top: 0 !important;
      left: 0 !important;
      height: auto !important;
      min-height: 110px;
      margin: 0 auto 20px !important;
      padding: 10px 0 !important;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch; // 弹性滚动-高级交互

      &::-webkit-scrollbar {
        height: 0;
      }

      .btn-item {
        position: relative !important;
        display: inline-flex !important;
        vertical-align: middle;
        top: 0 !important;
        left: 0 !important;
        width: 90px !important;
        height: 90px !important;
        margin: 0 6px !important;
        padding: 8px !important;
        flex-direction: column !important;
        gap: 6px !important;
        border-radius: $m-radius !important;
        background: linear-gradient(180deg, $primary-light, $primary) !important;
        box-shadow: $m-shadow !important;
        border: 2px solid transparent !important;
        transition: all 0.3s ease !important;

        .room-type {
          width: 100% !important;
          font-size: 12px !important;
          overflow: visible !important;
          color: $gray-light !important;
          font-weight: 500 !important;
        }

        .img {
          width: 45px !important;
          height: 45px !important;
          border-width: 1px !important;
          transform: none !important;
          opacity: 1 !important;
        }

        // 移动端选中态-高级高亮
        &.btn-active {
          width: 95px !important;
          height: 95px !important;
          background: linear-gradient(180deg, $primary-hover, $primary) !important;
          border-color: $white !important;
          box-shadow: $m-shadow-active !important;
          transform: translateY(-3px) !important;
          border-radius: $m-radius !important;

          .room-type {
            font-size: 13px !important;
            color: $white !important;
            font-weight: 600 !important;
          }

          .img {
            width: 50px !important;
            height: 50px !important;
            transform: scale(1.05) !important;
          }
        }

        // 禁用移动端hover/ready的冗余样式
        &:hover,
        &.btn-ready {
          width: 90px !important;
          height: 90px !important;
          background: linear-gradient(180deg, $primary-light, $primary) !important;

          .img {
            transform: none !important;
          }

          .room-type {
            font-size: 12px !important;
            width: 100% !important;
          }
        }
      }
    }

    .info-container {
      grid-template-columns: 1fr !important;
      gap: 20px !important;

      .info-left {
        order: 1;
        padding: 15px 20px !important;
        background: $gray-light;
        backdrop-filter: blur(10px);
        border-radius: $m-radius;
        box-shadow: $m-shadow;
        margin: 0 10px;

        .info-text {
          font-size: 14px !important;
          line-height: 1.7 !important;
          max-width: 100% !important;
          margin-bottom: 20px !important;
          color: #222 !important;
        }

        .btn-primary {
          padding: 10px 28px !important;
          font-size: 14px !important;
          border-radius: $m-radius !important;
        }
      }

      .info-right {
        order: 2;
        height: 320px !important;
        position: relative !important;
        padding: 0 !important;
        margin: 0 10px;

        .img-item {
          width: 85% !important;
          height: 45% !important;
          border-radius: $m-radius !important;
          border-width: 2px !important;
          box-shadow: $m-shadow !important;
          opacity: 1 !important;
          transition: none !important;
        }

        .up-img {
          top: 0 !important;
          right: 5% !important;
          left: auto !important;
          z-index: 2;
        }

        .down-img {
          bottom: 0 !important;
          left: 5% !important;
          right: auto !important;
          z-index: 1;
          opacity: 0.92 !important;
          transform: translateY(-5px) !important; // 层叠效果-高级感
        }

        // 禁用移动端图片动画
        .img-active-right,
        .img-active-left {
          left: auto !important;
          right: auto !important;
          box-shadow: $m-shadow !important;
        }
      }
    }
  }
}
</style>